import React from "react";
import { Icon } from "semantic-ui-react";

import styles from "./CategoryBreakdown.module.scss";

export function CategoryBreakdown({ categories = [], isLoading = false }) {
  const totalProducts = categories.reduce(
    (sum, category) => sum + category.products,
    0
  );

  const totalStock = categories.reduce(
    (sum, category) => sum + category.stock,
    0
  );

  return (
    <section className={styles.CategoryBreakdown}>
      <header className={styles.Header}>
        <div>
          <h2>Productos por categoría</h2>
          <p>Cuántos productos y piezas disponibles tiene cada categoría.</p>
        </div>
      </header>

      {isLoading ? (
        <div className={styles.EmptyState}>
          <span>Cargando...</span>
        </div>
      ) : categories.length === 0 ? (
        <div className={styles.EmptyState}>
          <Icon name="tags" />
          <span>Todavía no hay productos registrados.</span>
        </div>
      ) : (
        <div className={styles.TableWrapper}>
          <table className={styles.Table}>
            <thead>
              <tr>
                <th>Categoría</th>
                <th>Productos</th>
                <th>Piezas disponibles</th>
              </tr>
            </thead>

            <tbody>
              {categories.map((category) => (
                <tr key={category.id}>
                  <td className={styles.CategoryNameCell} title={category.name}>
                    {category.name}
                  </td>
                  <td>{category.products}</td>
                  <td>{category.stock}</td>
                </tr>
              ))}
            </tbody>

            <tfoot>
              <tr>
                <td>Total</td>
                <td>{totalProducts}</td>
                <td>{totalStock}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      )}
    </section>
  );
}
